import { useEffect, useMemo, useState } from "react";

import {
    termsData,
} from "./termsData";

export function useTermsViewModel() {
    const sections = useMemo(
        () => termsData,
        []
    );

    const [activeSection, setActiveSection] =
        useState(sections[0]?.id ?? "");

    const [scrollProgress, setScrollProgress] =
        useState(0);

    const [showHeader, setShowHeader] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight =
                document.documentElement.scrollHeight -
                window.innerHeight;

            setScrollProgress(
                docHeight > 0 ? (scrollTop / docHeight) * 100 : 0
            );

            setShowHeader(scrollTop > 240);
        };

        window.addEventListener("scroll", handleScroll);

        handleScroll();

        return () =>
            window.removeEventListener("scroll", handleScroll);
    }, []);



    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            {
                rootMargin: "-100px 0px -60% 0px",
                threshold: 0,
            }
        );

        sections.forEach((section) => {
            const element = document.getElementById(section.id);

            if (element) {
                observer.observe(element);
            }
        });

        return () => observer.disconnect();
    }, [sections]);

    const scrollToSection = (
        id: string
    ) => {
        document
            .getElementById(id)
            ?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return {
        sections,
        activeSection,
        scrollProgress,
        scrollToSection,
        scrollToTop,
        showHeader,
    };
}